export class SetupPayStepRequest {
    isPayStepEnabled: boolean;
    organisationId: number;
    financeManager: string;
    userId: number;

  }